export default () => [

  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'orderNo',
    title: '订单编号',
    align: 'center',
    fixed: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderType',
    align: 'center',
    width: 150,
    title: '订单类型',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'bizType',
    align: 'center',
    width: 150,
    title: '业务类型',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'transportMode',
    align: 'center',
    width: 150,
    title: '运输模式',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originProvinceName',
    align: 'center',
    width: 150,
    title: '始发地省份',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originCityName',
    align: 'center',
    width: 150,
    title: '始发地城市',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originName',
    align: 'center',
    width: 150,
    title: '始发地发货方',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickDateTime',
    align: 'center',
    width: 160,
    title: '实际提货时间',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationProvinceName',
    align: 'center',
    width: 150,
    title: '目的地省份',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationCityName',
    align: 'center',
    width: 150,
    title: '目的地城市',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationName',
    align: 'center',
    width: 150,
    title: '目的地收货方',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveDateTime',
    align: 'center',
    width: 160,
    title: '实际到货时间',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'feeName',
    align: 'center',
    width: 120,
    title: '费用名称',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'chargeUnit',
    align: 'center',
    width: 120,
    title: '计费单位',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'chargeQty',
    align: 'center',
    width: 120,
    title: '计费数量',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'price',
    align: 'center',
    width: 120,
    title: '计费单价',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'amount',
    align: 'center',
    width: 120,
    title: '计费总价',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'builderTime',
    align: 'center',
    width: 160,
    title: '生成时间',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    align: 'center',
    width: 150,
    title: '状态',
    slots: { default: 'status' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },

  {
    field: 'modifyTime',
    title: '修改时间',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    title: '修改人',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
